import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e0b0b3b6")

_pushScopeId("data-v-e0b0b3b6")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-box" }
const _hoisted_3 = { class: "message-box" }
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = { class: "message" }
const _hoisted_6 = { class: "dialog-button-box" }
const _hoisted_7 = { class: "negative-button-box" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_ctx.title)
                ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.message), 1)
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.negativeClicked(...args)))
                }, _toDisplayString(_ctx.negativeLabel), 1)
              ]),
              _createVNode("div", null, [
                _createVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.positiveClicked(...args)))
                }, _toDisplayString(_ctx.positiveLabel), 1)
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showDialog]
        ])
      ]),
      _: 1
    })
  ]))
})